import { apiUrl } from '../runtime'

// Browser replacement for createMarket: POST to core's backend with the shared session
// cookie. Mirrors @/app/actions/markets#createMarket.
export async function createMarket(data: {
  question: string
  description?: string
  categories?: string[]
  closes_at?: string
  restricted_user_ids?: number[]
  is_inside_joke?: boolean
  interaction_allowance?: string
  yes_label?: string
  no_label?: string
}): Promise<{ id?: number; error?: string }> {
  try {
    const res = await fetch(apiUrl('/api/markets'), {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    const json = await res.json().catch(() => ({}))
    if (!res.ok) return { error: json.detail ?? 'Failed to create market' }
    return { id: json.id }
  } catch {
    return { error: 'Failed to create market' }
  }
}
